import { Pipe, PipeTransform } from "@angular/core";
import { isNullOrUndefined } from "@asset-old/app/util/isNullOrUndefined.util";
import { ValidaCpfService } from "../services/valida-cpf.service";
import { ValidaCnpjService } from "../services/valida-cnpj.service";

@Pipe({
  name: "MaskCnpjCpfPipe",
  standalone: false,
})
export class MaskCnpjCpfPipe implements PipeTransform {
  constructor(
    private servicoValidadorCpf: ValidaCpfService,
    private servicoValidadorCnpj: ValidaCnpjService
  ) { }

  /**
   * Método responsável por manipular o texto e aplicar/remover máscara
   *
   * @param texto
   * @param removeMascara
   */
  transform(texto: string, removeMascara: boolean): string {
    if (!texto) return "";

    texto = this.retirarFormatacao(texto);

    if (removeMascara) {
      return texto;
    }

    if (texto.length === 11) {
      if (this.servicoValidadorCpf.validarCPF(texto)) {
        return this.mascaraCpf(texto);
      }
    } else if (texto.length === 14) {
      if (this.servicoValidadorCnpj.validarCNPJ(texto)) {
        return this.mascaraCnpj(texto);
      }
    }

    return texto;
  }

  /**
   * Método que remover caracteres especiais do texto
   *
   * @param texto
   */
  retirarFormatacao(texto: string): string {
    if (isNullOrUndefined(texto)) {
      return texto;
    }
    return texto.toString().replace(/(\.|\/|\-)/g, "");
  }

  /**
   * Método responsável por aplicar máscara de cpf ao texto
   *
   * @param valor
   */
  private mascaraCpf(valor: string): string {
    return valor
      .toString()
      .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  /**
   * Método responsável por aplicar máscara de cnpj ao texto
   *
   * @param valor
   */
  private mascaraCnpj(valor: string): string {
    if (valor === "Selecione") {
      return valor;
    }

    // Garante 14 caracteres, preenchendo à esquerda com zeros se necessário
    if (valor.length < 14) valor = valor.padStart(14, "0");

    // Novo formato: 12 alfanuméricos + 2 numéricos
    // Antigo formato: 14 numéricos
    // Ambos: XX.XXX.XXX/XXXX-XX
    return valor
      .toString()
      .replace(
        /^([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})(\d{2})$/,
        "$1.$2.$3/$4-$5"
      ).toUpperCase();
  }
}